module.exports = __webpack_public_path__ + "a9ab46a3db1b60b3168cae4b7e791acc.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/Logo-02.svg
// module id = 259
// module chunks = 0